import { SearchFacetOptions } from './search-facet-options.model';
import { SearchFacetFilter } from './search-facet-filter.model';
import { SearchFacetRangeFilter } from './search-facet-range-filter.model';
import { SearchOptions } from './search-options.model';

export class SearchResultRequest {
  public q: string;
  public facetOptions: SearchFacetOptions;
  public facetFilters: SearchFacetFilter[];
  public facetRangeFilters: SearchFacetRangeFilter[];
  public start: number;
  public rows: number;

  constructor(solrResults: any, options: SearchOptions) {
    this.q = options.q;
    this.facetOptions = options.facetOptions;
    this.facetFilters = options.facetFilters;
    this.facetRangeFilters = options.facetRangeFilters;

    this.start = solrResults.responseHeader.params.start;
    this.rows = solrResults.responseHeader.params.rows;
  }
}
